"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var index_1 = require("../constants/index");
exports.passwordValidator = function (control) {
  return control.value.length < index_1.MIN_PASSWORD_LENGTH ? {
    length: {
      value: control.value.length
    }
  } : null;
};
exports.passwordStrengthValidator = function (password) {
  var errors = [];
  var validators = [{
    message: "At least " + index_1.MIN_PASSWORD_LENGTH + " characters",
    passes: function (_password) {
      return _password.length >= index_1.MIN_PASSWORD_LENGTH;
    }
  }, {
    message: 'A lower case letter',
    passes: function (_password) {
      return !!_password.match(/[a-z]+/);
    }
  }, {
    message: 'An upper case letter',
    passes: function (_password) {
      return !!_password.match(/[A-Z]+/);
    }
  }, {
    message: 'At least one number',
    passes: function (_password) {
      return !!_password.match(/[0-9]+/);
    }
  }, {
    message: 'A special character (e.g. !@#$%)',
    passes: function (_password) {
      return !!_password.match(/[^a-zA-Z0-9\s]+/);
    }
  }];
  validators.forEach(function (validator) {
    var passes = validator.passes(password);
    if (!passes) {
      errors.push(validator.message);
    }
  });
  return errors.length > 0 ? errors : null;
};
